import { fetchApi } from '@/config/axiosSetting';
import { PatchCulpritPersonalInformationQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritPersonalInformation/patchCulpritPersonalInformationQuery.type';

export const patchCulpritPersonalInformationFunction = (
  params: PatchCulpritPersonalInformationQueryParamsType,
) => {
  return fetchApi.patch(
    `property/reports/${params?.id}/accident_users/culprit/user_information/driver/personal_information/`,
    params?.data,
    {
      params: {
        id: params?.id,
      },
    },
  );
};
